import { useEffect, useState } from "react";

import type { Emitter } from "@/lib/common";

export const useEmitter = <TEvent>(emitter: Emitter<[TEvent]>, initialState: TEvent) => {
  const [event, setEvent] = useState<TEvent>(initialState);

  useEffect(() => {
    const unsubscribe = emitter.on((event) => {
      setEvent(event);
    });

    return () => {
      unsubscribe();
    };
  }, [emitter]);

  return event;
};
